import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
import _imports_1 from '@/assets/qrcode.png';
const _withScopeId = n => (_pushScopeId("data-v-1bb66dc9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "relative h-full flex flex-col p-1 overflow-hidden whitespace-nowrap justify-between"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3/5 mx-auto mt-2 mb-5",
  style: {
    "min-height": "38.22px"
  },
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "flex items-center min-w-0"
};
const _hoisted_5 = {
  class: "whitespace-nowrap overflow-hidden text-ellipsis"
};
const _hoisted_6 = {
  class: "group-hover:block hidden"
};
const _hoisted_7 = {
  class: "actions p-2 text-sm"
};
const _hoisted_8 = {
  class: "flex p-2 items-center"
};
const _hoisted_9 = {
  class: "flex flex-1 items-center"
};
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  class: "id"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text-center"
}, "微信扫码进行咨询")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Fold = _resolveComponent("Fold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ChatSquare = _resolveComponent("ChatSquare");
  const _component_EditPen = _resolveComponent("EditPen");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_Present = _resolveComponent("Present");
  const _component_ai_dot = _resolveComponent("ai-dot");
  const _component_Phone = _resolveComponent("Phone");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    ref: "target",
    class: _normalizeClass(["fixed md:relative chat-slider-wrapper bg-slate-950 text-white text-sm", {
      'other-fixed': _ctx.route.name !== 'chat',
      'w-0': !_ctx.sliderShow
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["h-full overflow-hidden box-border w-60 flex-none flex flex-col chat-slider border-r relative", {
      'w-0': !_ctx.sliderShow
    }])
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_icon, {
    onClick: _ctx.toggle,
    class: "absolute right-1 text-gray-300 top-4 cursor-pointer",
    size: "20"
  }, {
    default: _withCtx(() => [_createVNode(_component_Fold)]),
    _: 1
  }, 8, ["onClick"]), _ctx.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.create && _ctx.create(...args)),
    class: "select-none cursor-pointer text-xs text-indigo-400 rounded h-14 border border-dashed border-indigo-400 flex items-center justify-center"
  }, " + 创建新的聊天 ")) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
    class: "flex-auto mt-3"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, item => {
      return _openBlock(), _createElementBlock("div", {
        onClick: $event => _ctx.changeSession(item.id),
        class: _normalizeClass(["group p-3 flex items-center rounded hover:bg-slate-400/10 cursor-pointer justify-between", {
          'bg-slate-400/20': _ctx.sessionActive === item.id
        }]),
        key: item.id
      }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
        class: "mr-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_ChatSquare)]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
        class: "mr-2",
        onClick: _withModifiers($event => _ctx.edit(item), ["stop"])
      }, {
        default: _withCtx(() => [_createVNode(_component_EditPen)]),
        _: 2
      }, 1032, ["onClick"]), _createVNode(_component_el_icon, {
        onClick: _withModifiers($event => _ctx.del(item.id), ["stop"])
      }, {
        default: _withCtx(() => [_createVNode(_component_Delete)]),
        _: 2
      }, 1032, ["onClick"])])], 10, _hoisted_3);
    }), 128))]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [_ctx.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.cleanAll && _ctx.cleanAll(...args)),
    class: "p-3 pl-5 bg-white text-black rounded mb-2 cursor-pointer flex items-center"
  }, [_createVNode(_component_el_icon, {
    class: "mr-1"
  }, {
    default: _withCtx(() => [_createVNode(_component_Delete)]),
    _: 1
  }), _createTextVNode("清除会话 ")])) : _createCommentVNode("", true), _ctx.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.showVip && _ctx.showVip(...args)),
    class: "relative p-3 pl-5 bg-white text-black rounded mb-2 cursor-pointer flex items-center"
  }, [_createVNode(_component_el_icon, {
    class: "mr-1"
  }, {
    default: _withCtx(() => [_createVNode(_component_Present)]),
    _: 1
  }), _createTextVNode("升级会员 "), _createVNode(_component_ai_dot, {
    target: "upgrade"
  })])) : _createCommentVNode("", true), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.showServiceDialog && _ctx.showServiceDialog(...args)),
    class: "p-3 pl-5 bg-white text-black rounded mb-2 cursor-pointer flex items-center"
  }, [_createVNode(_component_el_icon, {
    class: "mr-1"
  }, {
    default: _withCtx(() => [_createVNode(_component_Phone)]),
    _: 1
  }), _createTextVNode("专属客服 ")]), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.download && _ctx.download(...args)),
    class: "hidden sm:block text-xs p-3 pl-5 bg-white text-black rounded mb-2 cursor-pointer flex items-center"
  }, " 点击下载 / CTRL+D 收藏本站 ")]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_avatar, {
    onClick: _ctx.showUserInfo,
    class: "mr-3",
    size: 40,
    src: _ctx.userInfo.avatar || require('@/assets/no_avatar.png')
  }, null, 8, ["onClick", "src"]), _createElementVNode("div", _hoisted_9, [!_ctx.userInfo.nickname ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "no-login cursor-pointer",
    onClick: _cache[5] || (_cache[5] = (...args) => _ctx.login && _ctx.login(...args))
  }, " 未登录，点此登录 ")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "cursor-pointer",
    onClick: _cache[6] || (_cache[6] = (...args) => _ctx.showUserInfo && _ctx.showUserInfo(...args))
  }, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userInfo.nickname), 1), _createElementVNode("div", _hoisted_11, "ID:" + _toDisplayString(_ctx.userInfo.user_id), 1)]))]), _ctx.userInfo.nickname ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "flex-none text-xs cursor-pointer",
    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.logout && _ctx.logout(...args))
  }, " 退出登录 ")) : _createCommentVNode("", true)])])], 2)], 2), _createVNode(_component_el_dialog, {
    center: "",
    modelValue: _ctx.showService,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.showService = $event),
    width: "440px",
    title: "专属客服",
    "append-to-body": ""
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["modelValue"])], 64);
}